"use strict";
export var PopupType = /* @__PURE__ */ ((PopupType2) => {
  PopupType2["Transaction"] = "transaction";
  PopupType2["Order"] = "order";
  PopupType2["FailedSwitchNetwork"] = "failedSwitchNetwork";
  PopupType2["SwitchNetwork"] = "switchNetwork";
  PopupType2["Bridge"] = "bridge";
  PopupType2["Mismatch"] = "mismatch";
  PopupType2["LiquiditySuccess"] = "liquiditySuccess";
  PopupType2["LiquidityError"] = "liquidityError";
  PopupType2["LockSuccess"] = "lockSuccess";
  PopupType2["LockError"] = "lockError";
  PopupType2["VotingSuccess"] = "votingSuccess";
  PopupType2["VotingError"] = "votingError";
  PopupType2["IncentiveSuccess"] = "incentiveSuccess";
  PopupType2["IncentiveError"] = "incentiveError";
  PopupType2["StakeSuccess"] = "stakeSuccess";
  PopupType2["StakeError"] = "stakeError";
  PopupType2["UnstakeSuccess"] = "unstakeSuccess";
  PopupType2["UnstakeError"] = "unstakeError";
  PopupType2["ClaimRewardsSuccess"] = "claimRewardsSuccess";
  PopupType2["ClaimRewardsError"] = "claimRewardsError";
  PopupType2["ClaimFeesSuccess"] = "claimFeesSuccess";
  PopupType2["ClaimFeesError"] = "claimFeesError";
  PopupType2["SimpleMessage"] = "simpleMessage";
  PopupType2["NewVersion"] = "newVersion";
  return PopupType2;
})(PopupType || {});
